import { makeAutoObservable } from 'mobx';
import HaptikService from '../services/api/haptik';
import { HaptikEvent, HaptikInitconfig } from '../models/haptik';

import { environment } from '../../../environments/environment';
import { StorageHelper } from '../services/storage';
import { CacheAreaKey } from '../config/cache-config';
import { ConnectStore } from './auth.store';
import { HaptikEventName } from '../enums/haptik-events';

export class HaptikStore {
  isLoading!: boolean;
  canSignIn = false;
  isOpened = false;
  isScriptLoaded = false;
  useCustomButton = false;

  haptikGuestConfig: HaptikInitconfig = {
    'business-id': environment.HAPTIK_CONCIERGE_BUSINESS_ID,
    'client-id': environment.HAPTIK_CONCIERGE_CLIENT_ID,
    'base-url': environment.HAPTIK_BASE_URL,
    'privacy-policy-url': environment.HAPTIK_PRIVACY_POLICY_URL,
    'blacklisted-params': '',
    'custom-css': '',
    'initialize-language': 'en',
    sdkEvents: (event: any) => {
      this.handleSDKEvent(event);
    },
  };
  haptikSignInConfig: HaptikInitconfig = { ...this.haptikGuestConfig, 'signup-type': 'third_party' };

  currentConfig = this.haptikSignInConfig;
  constructor() {
    makeAutoObservable(this);
  }

  onInit() {
    if (!this.isScriptLoaded) {
      HaptikService.loadHaptikScript();
      this.changeIsScriptLoaded(true);

      HaptikService.initialise(this.haptikGuestConfig);

      HaptikService.waitForSDK().then(() => {
        if (this.useCustomButton) {
          const wrapper = document.getElementById('haptik-xdk-wrapper');
          wrapper?.classList.add('hide-haptik-button');
        }
        this.changeCanSignIn(true);
      });
    }
  }

  loadSignInBot() {
    HaptikService.replaceSDK(this.haptikSignInConfig);
    HaptikService.waitForSDK().then(() =>
      HaptikService.signIn(StorageHelper.GetInstance.getFromCache('conf', 'connect', CacheAreaKey.Customer) as ConnectStore)
    );
  }

  handleSDKEvent(event: HaptikEvent) {
    if (event.event_name === HaptikEventName.HAPTIK_APP_EXPANDED) {
      this.changeIsOpened(true);
    }
    if (event.event_name === HaptikEventName.HAPTIK_APP_MINIMIZED) {
      this.changeIsOpened(false);
    }
  }

  showApp() {
    HaptikService.showApp();
  }

  hideApp = () =>  {
    HaptikService.hideApp();
    //FIXME: Hiding app via Haptik.hide() is not triggering minimised Event
    this.changeIsOpened(false);
  }

  changeIsLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }
  changeIsOpened(_value: boolean) {
    this.isOpened = _value;
  }
  changeCurrentConfig(_value: HaptikInitconfig) {
    this.currentConfig = _value;
  }
  changeIsScriptLoaded(_value: boolean) {
    this.isScriptLoaded = _value;
  }
  changeCanSignIn(_value: boolean) {
    this.canSignIn = _value;
  }
  changeUseCustomButton(_value: boolean) {
    this.useCustomButton = _value;
  }
}
